import { useAuthenticatedFetch } from './useAuthenticatedFetch';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { config } from '../config';

/**
 * A hook for querying your custom app data.
 * @param {string} url The url to query
 * @param {Object} [options] The options for your query. See: https://tanstack.com/query/latest/docs/react/reference/useQuery
 * @returns Return value of useQuery
 */
export const useAppQuery = (url, options = {}) => {
  const authenticatedFetch = useAuthenticatedFetch();
  const queryFn = useMemo(() => {
    return async () => {
      const fullUrl = url.startsWith('/') ? `${config.apiBaseUrl}${url}` : url;
      const response = await authenticatedFetch(fullUrl);
      if (!response) return null;
      return response.json();
    };
  }, [url, authenticatedFetch]);

  return useQuery({
    queryKey: [url],
    queryFn,
    ...options,
  });
};
